import { gql } from '../types/generated/gql';

export const GET_LITMUS_SCHEDULE = gql(`
  query litmusSchedule($date: String = "", $sports: [Sport] = [MLB]) {
    schedule(date: $date, sports: $sports) {
      away {
        ...TeamFields
      }
      home {
        ...TeamFields
      }
      venue {
        id
        name
      }
      gameDate
      gamePk
      status
    }
  }
`);

export const GET_LITMUS_VALIDATION_SCHEMAS = gql(`
  query validationSchemas {
    validationSchemas {
      validationProcess
      rules {
        name
        description
      }
    }
  }
`);
